<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">{{ ticket.name }}</div>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form class="form">
        <!-- Descrição -->
        <label>Descrição</label>
        <textarea v-model="ticket.ticketDesc" rows="3" placeholder="Descrição do tipo de ingresso ..." />

        <button @click="saveTicket(ticket)" class="button-save" style="margin-top: 30px"><i class="fas fa-check"></i><span>Salvar</span></button>
      </form>
    </div>
  </section>
</template>

<script>
import { updatePrice } from '../api/showDate'
export default {
  name: 'TicketTypeDesc',
  props: ['ticket', 'close', 'showDate'],
  data () {
    return {
      loading: false,
      desc: null
    }
  },
  methods: {
    async saveTicket (price) {
      await updatePrice(
        price.id,
        Number(this.showDate),
        price.name,
        price.value,
        price.sell,
        price.active,
        price.ticketDesc
      )
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../admin/_asset/scss/_variables";
@import "../../admin/_asset/scss/register";

.pay-label {
  color: $primary-color;
  font-weight: 500;
  font-size: 0.85em;
}
</style>
